import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';


import { EnvironmentService } from '../environment.service';
import { ServiceCompaniesSearchModel as ServiceCompanySearchModel } from '../../models/service-companies/serviceCompaniesSearch';
import * as ServiceCompanyModels from '../../models/service-companies/serviceCompanies';
import { HelperService } from '../helper/helper.service';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})


export class ServiceCompaniesService {

  constructor(private httpClient: HttpClient,
              private environmentService: EnvironmentService,
              private helperService: HelperService
  ) { }


  public get(Search: ServiceCompanySearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<ServiceCompanyModels.ServiceCompaniesListModel>(`${this.environmentService.getApiURL()}/servicecompany/list`, Search, options);
  }

  public getServiceCompaniesTypesDictionary() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.get<ServiceCompanyModels.ServiceCompaniesTypesListModel>(`${this.environmentService.getApiURL()}/servicecompany/type`, options);
  }

  public getServiceCompaniesDictionary() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');
    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.get<ServiceCompanyModels.ServiceCompaniesDictionary>(`${this.environmentService.getApiURL()}/servicecompany/dictionary`, options);
  }

  public insert(ServiceCompany: ServiceCompanyModels.ServiceCompanyBaseModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<ServiceCompanyModels.ServiceCompanyModel>(`${this.environmentService.getApiURL()}/servicecompany/insert`, ServiceCompany, options);
  }

  public set(ServiceCompany: ServiceCompanyModels.ServiceCompanyModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<HttpEventType>(`${this.environmentService.getApiURL()}/servicecompany/set`, ServiceCompany, options);

  }

  public getServiceCompany(ServiceCompanyId: number) {
    return this.httpClient.get<ServiceCompanyModels.ServiceCompanyObjectModel>(`${this.environmentService.getApiURL()}/servicecompany/servicecompany/${ServiceCompanyId}`);
  }

  public uploadFile( formData ) {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post(`${this.environmentService.getApiURL()}/servicecompany/upload/document`, formData , {reportProgress: true, observe: 'events'});
  }

  // tslint:disable: max-line-length
  public getFile(serviceCompanyId: number, fileType: string) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};

    if (fileType === 'AgreementFileName') {

      return this.httpClient.get<Blob>(`${this.environmentService.getApiURL()}/servicecompany/servicecompany/${serviceCompanyId}/get/agreement`, options);

    } else if (fileType === 'OtherFileName') {

      return this.httpClient.get<Blob>(`${this.environmentService.getApiURL()}/servicecompany/servicecompany/${serviceCompanyId}/get/other`, options);

    } else {

      throwError('[GarageService.getFile] Unexpected input');
      return;
    }
  }

  public getReport(search: ServiceCompanySearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/servicecompany/report/filtered`, search, options);

  }

}
